import { render } from "./LinkWarningModal.vue?vue&type=template&id=da8ac128&scoped=true"
import script from "./LinkWarningModal.vue?vue&type=script&lang=js"
export * from "./LinkWarningModal.vue?vue&type=script&lang=js"

import "./LinkWarningModal.vue?vue&type=style&index=0&id=da8ac128&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.18_vue@3.5.18_webpack@5.101.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da8ac128"]])

export default __exports__